export default __webpack_public_path__ + "static/media/StartDemo.7639d91a.mp3";